import { handleApiCall } from "../api";

export const getNotification = (data = null, config = {},isLoading=false) => handleApiCall('get' , `/audit-logs`,data, config,isLoading);

export const updateNotification = (id,payload) => handleApiCall('patch' , `/audit-logs/${id}`,payload);